import MainLayout from "@/components/layout/MainLayout";
import { SEO } from "@/components/seo/SEO";
import { ModelWorkspaceProvider } from "@/contexts/ModelWorkspaceContext";
import { ModelBuilder } from "@/components/predictive/ModelBuilder";
import { ModelTraining } from "@/components/predictive/ModelTraining";
import { ModelInsights } from "@/components/predictive/ModelInsights";
import { ModelPerformance } from "@/components/predictive/ModelPerformance";
import { ModelTuning } from "@/components/predictive/ModelTuning";
import { ModelDeployment } from "@/components/predictive/ModelDeployment";
import { AIInsightGenerator } from "@/components/ai/AIInsightGenerator";
import { NaturalLanguageQuery } from "@/components/ai/NaturalLanguageQuery";
import { PredictiveModelingAI } from "@/components/ai/PredictiveModelingAI";
import { MasterAutomationControl } from "@/components/automation/MasterAutomationControl";

const PredictiveModels = () => {
  return (
    <MainLayout>
      <SEO title="Predictive Models — Veylo AI" description="Build, train, tune and deploy predictive models on your own data, with AI insights and natural-language querying." path="/predictive-models" />
      <ModelWorkspaceProvider>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">AI-Powered Predictive Models</h1>
        <p className="text-muted-foreground mb-6">
          Use advanced AI to build predictive models, generate insights, and forecast trends based on your cleaned data.
        </p>
        
        {/* New AI Features Section */}
        <div className="grid gap-6">
          <div className="grid lg:grid-cols-2 gap-6">
            <AIInsightGenerator />
            <NaturalLanguageQuery />
          </div>
          <PredictiveModelingAI />
        </div>

        <MasterAutomationControl />
        
        {/* Existing Model Components */}
        <div className="grid gap-6">
          <ModelTraining />
          <div className="grid lg:grid-cols-2 gap-6">
            <ModelBuilder />
            <ModelTuning />
          </div>
          <ModelPerformance />
          <ModelInsights />
          <ModelDeployment />
        </div>
      </div>
      </ModelWorkspaceProvider>
    </MainLayout>
  );
};

export default PredictiveModels;
